<template>

    <div class="outer-content foreground blur">
      <div class="inner-content">
        <div class="exit_btn" @click="$emit('hide-resource-box')"><img src="../assets-fca/UI/close_gray.svg"></div>
        <div class="scroll_content">
          <div class="grid_container">
            <!--Top section-->
            <div id="top" v-html="T('resources_1')"></div>
            <div id="top" v-html="T('resources_2')"></div>
            <!--What's happening info-->
            <div id="happening" v-html="T('resources_3')"></div>
            <div id="happening" v-html="T('resources_4')"></div>
            <div id="happening" v-html="T('resources_5')"></div>
            <div id="happening" v-html="T('resources_6')"></div>
            <div id="happening" v-html="T('resources_7')"></div>
            <div id="happening" v-html="T('resources_8')"></div>
            <div id="happening" v-html="T('resources_9')"></div>
            <div id="happening" v-html="T('resources_10')"></div>
            <div id="happening" class="happen_video" v-html="T('resources_11')"></div>
            <div id="happening" v-html="T('resources_12')"></div>
            <!--What is an event-->
            <div id="event" v-html="T('resources_13')"></div>
            <div id="event" v-html="T('resources_14')"></div>
            <div id="event" class="event_video" v-html="T('resources_15')"></div>
            <!--Options-->
            <div id="option" v-html="T('resources_16')"></div>
            <div id="option" v-html="T('resources_17')"></div>
            <div id="option" v-html="T('resources_18')"></div>
            <!--Resources for Students-->
            <div id="student" v-html="T('resources_19')"></div>
            <div id="student" v-html="T('resources_20')"></div>
            <div id="student" v-html="T('resources_21')"></div>
            <div id="student" v-html="T('resources_22')"></div>
            <!--Rescoures for Teachers-->
            <div id="teacher" v-html="T('resources_23')"></div>
            <div id="teacher" v-html="T('resources_24')"></div>
            <div id="teacher" v-html="T('resources_25')"></div>
            <!--Serious games-->
            <div id="serious" v-html="T('resources_26')"></div>
            <div id="serious" v-html="T('resources_27')"></div>
            <div id="serious" v-html="T('resources_28')"></div>
            <div id="serious" v-html="T('resources_29')"></div>
            <div id="serious" v-html="T('resources_30')"></div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { T } from '@/App.vue';
  import Vue from 'vue';
  
  export default Vue.extend({
    name: 'ResourceBox',
    methods: {
      T(key: string): string {
        return T(key);
      }
    }
  });
  </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="less">
  
  /*Resource box general*/
.inner-content {
  height: 800px;
  width: 1150px;
  background-color: white;
  border-radius: 20px;
}

.scroll_content {
  width: 1050px;
  height: 650px;
  margin: auto;
  margin-top: 80px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.exit_btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.grid_container {
  display: grid;
  grid-template-columns: 202px 623px 202px;
  grid-template-rows: repeat(auto);
  row-gap: 10px;
}
  
#top, #happening, #event, #option, #student, #teacher, #serious {
  grid-column: span 3;
}

.happen_video, .event_video {
  width: 600px;
  height: 350px;
  grid-column: 2;
  margin: auto;
}
  </style>

<style>
.links {
  color: #333333;
}
</style>